/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('cloneEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./clone-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        function ($scope) {
          $scope.onValidityChange(true);
        },
      ],
    };
  },
]);
